import { CSpinner } from "@coreui/react";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { apiCall } from "src/_apiConfig/apiCall";

const SenctionLetter = () => {
  let { id } = useParams();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => generateLetter(), []);

  const [loading, setloading] = useState(false);

  const generateLetter = async () => {
    setloading(true);
    const header = new Headers();
    const response = await apiCall(
      `Tender/GenerateSanctionLetter?TenderId=${id}`,
      "GET",
      header,
      null
    );
    await response.json();
    if (response.status === 200) {
      setloading(false);
    }
    setloading(false);
  };
  return (
    <>
      {loading ? (
        <CSpinner className="spinner-grow" color="success" />
      ) : (
        <>senction Letter</>
      )}
    </>
  );
};
export default SenctionLetter;
